/**
 * Utility function to format API event values into human-readable labels
 * Converts camelCase/PascalCase API enum values to user-friendly display text
 */
export function ceLabelFormatterUtil(eventValue: string): string {
  if (!eventValue) return '';

  // Convert camelCase/PascalCase to readable format
  return (
    eventValue
      // Add space before capital letters
      .replace(/([A-Z])/g, ' $1')
      // Trim leading space and handle multiple spaces
      .trim()
      .replace(/\s+/g, ' ')
      // Apply specific formatting rules
      .replace(/Bonus Issue Capitalisation Issue/g, 'Bonus Issue/Capitalisation Issue')
      .replace(
        /Cash Distribution From Non Eligible Securities Sales/g,
        'Cash Distribution From Non-Eligible Securities Sales'
      )
      .replace(/Extraordinary Or Special General Meeting/g, 'Extraordinary or Special General Meeting')
      .replace(/Full Call Early Redemption/g, 'Full Call/Early Redemption')
      .replace(/Interest Payment With Principal/g, 'Interest Payment with Principal')
      .replace(/Liquidation Dividend Liquidation Payment/g, 'Liquidation Dividend/Liquidation Payment')
      .replace(/Non U S T E F R A D Certification/g, 'Non-US TEFRA D Certification')
      .replace(/Odd Lot Sale Purchase/g, 'Odd Lot Sale/Purchase')
      .replace(/Partial Defeasance Pre Funding/g, 'Partial Defeasance/Pre-Funding')
      .replace(
        /Partial Redemption With Reduction Of Nominal Value/g,
        'Partial Redemption With Reduction of Nominal Value'
      )
      .replace(
        /Partial Redemption Without Reduction Of Nominal Value/g,
        'Partial Redemption Without Reduction of Nominal Value'
      )
      .replace(/Place Of Incorporation/g, 'Place of Incorporation')
      .replace(/Pari Passu/g, 'Pari-Passu')
      .replace(/Reverse Stock Split Change In Nominal Value/g, 'Reverse Stock Split/Change in Nominal Value')
      .replace(/Spin Off/g, 'Spin-Off')
      .replace(/Stock Split Change In Nominal Value Subdivision/g, 'Stock Split/Change in Nominal Value/Subdivision')
      .replace(/Trading Status Active/g, 'Trading Status: Active')
      .replace(/Trading Status Delisted/g, 'Trading Status: Delisted')
      .replace(/Trading Status Suspended/g, 'Trading Status: Suspended')
      .replace(/Call On Intermediate Securities/g, 'Call on Intermediate Securities')
      .replace(/Rights Issue Subscription Rights Rights Offer/g, 'Rights Issue/Subscription Rights/Rights Offer')
      .replace(/Scrip Dividend Payment/g, 'Scrip Dividend/Payment')
      .replace(/Class Action Proposed Settlement/g, 'Class Action/Proposed Settlement')
      .replace(/Non Official Offer/g, 'Non-Official Offer')
      .replace(/Repurchase Offer Issuer Bid Reverse Rights/g, 'Repurchase Offer/Issuer Bid/Reverse Rights')
      .replace(/Tender Acquisition Takeover Purchase Offer/g, 'Tender/Acquisition/Takeover/Purchase Offer')
  );
}
